"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargeTitle = exports.ModalTitle = exports.Header = exports.Body = exports.ModalBox = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../../Layout/Box"));

var _Flex = _interopRequireDefault(require("../../Layout/Flex"));

var _Heading = _interopRequireDefault(require("../../Elements/Heading"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalBox = (0, _styledComponents.default)(_Box.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  position: relative;\n  background-color: white;\n  z-index: 1001;\n  max-width: 600px;\n"], ["\n  position: relative;\n  background-color: white;\n  z-index: 1001;\n  max-width: 600px;\n"])));
exports.ModalBox = ModalBox;
ModalBox.defaultProps = {
  mx: 'auto',
  my: [0, '5%'],
  width: [1, 3 / 4]
};
var Body = (0, _styledComponents.default)(_Box.default)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.Body = Body;
Body.defaultProps = {
  p: 5,
  pt: 0
};
var Header = (0, _styledComponents.default)(_Flex.default)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.Header = Header;
Header.defaultProps = {
  justifyContent: 'space-between',
  p: 5,
  width: 1
};
var ModalTitle = (0, _styledComponents.default)(_Heading.default)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.ModalTitle = ModalTitle;
ModalTitle.defaultProps = {
  as: 'h2',
  m: 0,
  fontSize: 6
};
var LargeTitle = (0, _styledComponents.default)(_Heading.default).attrs({
  px: 5
})(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)(["\n  font-weight: bold;\n  margin-bottom: 24px;\n  max-width: 370px;\n  text-align: center;\n  text-transform: uppercase;\n"], ["\n  font-weight: bold;\n  margin-bottom: 24px;\n  max-width: 370px;\n  text-align: center;\n  text-transform: uppercase;\n"])));
exports.LargeTitle = LargeTitle;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;